<template>
    <div class="container">
        <b-modal
            :model-value="showDialogInfo"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            size="lg"
            :title="labels.listSubsidiary"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog list-subsidiary-dialog"
         @hide="clicked">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ companyName?.nombre }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Lista de Subsidiarias -->
                <div v-if="Item?.length > 0">
                    <b-row class="d-flex align-items-center uniform-form-row" style="border-bottom: 1px solid #e0e0e0; padding-bottom: 8px; margin-bottom: 8px;">
                        <b-col cols="6" class="text-left">
                            <strong>{{ labels.subsidiary }}</strong>
                        </b-col>
                        <b-col cols="3" class="text-right">
                            <strong>{{ labels.stake }}</strong>
                        </b-col>
                        <b-col cols="3" class="text-center">
                            <strong>{{ labels.actions }}</strong>
                        </b-col>
                    </b-row>
                    <b-row 
                        v-for="subsidiary in Item" 
                        :key="`${subsidiary.id_compania}-${subsidiary.id_subsidiaria}`" 
                        class="d-flex align-items-center uniform-form-row"
                    >
                        <b-col cols="6" class="text-left">
                            <span>{{ getNameSubsidiary(subsidiary?.id_subsidiaria) }}</span>
                        </b-col>
                        <b-col cols="3" class="text-right">
                            <span>{{ subsidiary.participacion }} %</span>
                        </b-col>
                        <b-col cols="3" class="text-center">
                            <b-button
                                size="sm"
                                class="reset-btn-danger"
                                style="width: 32px; height: 32px; padding: 0; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center;"
                                @click="confirmDeleteSubsidiary(subsidiary)"
                            >
                                <font-awesome-icon :icon="['fas', 'trash']" style="font-size: 12px;" />
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div v-else class="text-center text-muted py-3">
                    <p>{{ labels.noSubsidiaries }}</p>
                </div>

                <!-- Botón para mostrar formulario -->
                <div class="text-center mt-3" v-if="!showRow">
                    <b-button
                        class="reset-btn-primary"
                        @click="newSubsidiary"
                    >
                        <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                        {{ labels.addSubsidiary }}
                    </b-button>
                </div>

                <!-- Formulario para agregar nueva subsidiaria -->
                <div v-if="showRow" class="mt-4">
                    <h5 class="mb-3" style="color: #016690; font-weight: 600;">{{ labels.addSubsidiary }}</h5>

                    <b-row class="d-flex align-items-end uniform-form-row">
                        <b-col cols="12" md="5" class="text-left">
                            <label class="form-label">{{ labels.subsidiary }}</label>
                            <b-form-select
                                v-model="selSubsidiary"
                                class="form-input"
                            >
                                <option value="" disabled>-- {{ labels.selectSubsidiary }} --</option>
                                <option v-for="comp in listCompany" :key="comp?.id" :value="comp?.id">
                                    {{ comp?.nombre }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" md="4" class="text-left">
                            <label class="form-label">{{ labels.stake }}</label>
                            <b-form-input
                                v-model="cantPartici"
                                type="number"
                                class="form-input"
                                placeholder="%"
                                min="0"
                                max="100"
                            />
                        </b-col>
                        <b-col cols="12" md="3" class="text-left">
                            <b-button
                                class="reset-btn-primary"
                                @click="createSubsidiary"
                                style="width: 100%; margin-top: 24px;"
                            >
                                {{ labels.create }}
                            </b-button>
                        </b-col>
                    </b-row>
                </div>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import Company from "../../services/Company" 
import Subsidiary from "../../services/Subsidiary" 
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "ListSubsidiary",
    components: {
        InacticaItem
    },
    props: ['showDialogInfo', 'Item', 'companyName'],
    data: () => ({
        listCompany: [],
        listCompanySub: [],
        showRow: false,
        selSubsidiary: "",
        cantPartici: "",
        error: false,
        showDeleteModal: false,
        subsidiaryToDelete: null
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    listSubsidiary: "Lista de Subsidiarias",
                    subsidiary: "Subsidiaria",
                    stake: "Participación",
                    matrix: "Matriz:",
                    create: "Crear",
                    save: "Guardar",
                    close: "Cerrar",
                    addSubsidiary: "Añadir Subsidiaria",
                    selectSubsidiary: "Seleccione una subsidiaria",
                    noSubsidiaries: "No hay subsidiarias registradas",
                    actions: "Acciones",
                    infoText: "Lista de subsidiarias asociadas a esta compañía."
                }
            } else {
                return {
                    listSubsidiary: "List of Subsidiaries",
                    subsidiary: "Subsidiary",
                    stake: "Stake",
                    matrix: "Matrix:",
                    create: "Create",
                    save: "Save",
                    close: "Close",
                    addSubsidiary: "Add Subsidiary",
                    selectSubsidiary: "Select a subsidiary",
                    noSubsidiaries: "No subsidiaries registered",
                    actions: "Actions",
                    infoText: "List of subsidiaries associated with this company."
                }
            }
        }
    },
    methods: {
        clicked() {
            this.selSubsidiary = ""
            this.cantPartici = ""
            this.showRow = false
            this.$emit('clicked', false)
        },
        getNameSubsidiary(id) {
            let objSubsidiary = this.listCompanySub.find((obj) => obj.id === id)
            return objSubsidiary ? `${objSubsidiary?.codigo} ${objSubsidiary?.nombre}` : 'N/A'
        },
        newSubsidiary() {
            this.showRow = true
            
            this.listCompany = [...this.listCompanySub]
            
            if (this.Item.length != 0) {
                this.Item.forEach(element => {
                    this.listCompany = this.listCompany.filter((compId) => 
                        compId.id != element.id_subsidiaria && compId.id != this.companyName.id
                    )
                })
            } else {
                this.listCompany = this.listCompany.filter((compId) => compId.id != this.companyName.id)
            }
            
            return this.listCompany
        },
        createSubsidiary() {
            if (this.selSubsidiary == "") {
                this.$toast.error("El campo Subsidiaria debe ser diligenciado")
                return
            }
            if (this.cantPartici == "") {
                this.$toast.error("El campo Participación debe ser diligenciado")
                return
            }
            if (this.cantPartici < 0 || this.cantPartici > 100) {
                this.$toast.error("El campo Participación debe estar entre 0 y 100")
                return
            }

            let form = {
                'idMatriz': this.companyName.id,
                'idSubsidiaria': this.selSubsidiary,
                'participacion': this.cantPartici,
                'idUser': this.$store.state.userId,
            }

            Subsidiary.createMatrizSubsi(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.$emit('subsidiaryCreated')
                    this.clicked()
                })
                .catch((error) => {
                    this.$toast.error(error.response?.data?.message || "La matriz no puede tener esta compañía como subsidiaria, ya que esta es su matriz principal")
                    this.error = true
                })
        },
        confirmDeleteSubsidiary(subsidiary) {
            this.subsidiaryToDelete = subsidiary
            this.showDeleteModal = true
        },
        closeDeleteModal() {
            this.showDeleteModal = false
            this.subsidiaryToDelete = null
        },
        confirmDelete() {
            if (!this.subsidiaryToDelete) return
            this.deleteSubsidiary(this.subsidiaryToDelete)
        },
        deleteSubsidiary(subsidiary) {
            if (!subsidiary) return

            const companyId = this.companyName?.id
            const subsidiaryId = subsidiary?.id_subsidiaria

            if (!companyId || !subsidiaryId) return

            Subsidiary.deleteMatrizSubsi(companyId, subsidiaryId)
                .then((res) => {
                    this.$toast.success(res.data.message || "Subsidiaria eliminada correctamente.")
                    this.showDeleteModal = false
                    this.subsidiaryToDelete = null
                    this.$emit('subsidiaryDeleted')
                })
                .catch((error) => {
                    this.$toast.error(error.response?.data?.message || "No fue posible eliminar la subsidiaria.")
                })
        }
    },
    mounted() {
        Company.getAllCompanies()
            .then((result) => {
                this.listCompany = result.data.companies
                this.listCompanySub = result.data.companies
            })
            .catch((error) => {
                console.log(error)
            })
    },
    watch: {
        showDialogInfo(val) {
            if (val) {
                this.listCompany = [...this.listCompanySub]
                this.showRow = false
                this.selSubsidiary = ""
                this.cantPartici = ""
            }
        }
    }
}
</script>

<style src="../main.css"></style>